import { FC } from 'react'

import { useI18n } from '../../../hooks'
import FindMySchoolForm from '../../findMySchool/findMySchoolForm'

import './index.css'

const FacultySchool: FC = () => {
  const { t } = useI18n()
  return (
    <div className="faculty-school" id="faculty-school">
      <h1 className="faculty-school-title heavy">{t('FacultySchool_findYourSchool')}</h1>
      <p className="faculty-school-title-description">{t('FacultySchool_useSchoolFinder')}</p>
      <FindMySchoolForm />
    </div>
  )
}

export default FacultySchool
